import { Component, OnInit } from '@angular/core';
import { TeacherProvider } from '../../providers/teacher/teacher.provider';
import { Teacher } from '../../models/teacher';
import { Course } from '../../models/course';
import { Collection } from '../../models/collection';
import { PreferencesProvider } from '../../providers/preferences/preferences.provider';
import { MenuPopoverComponent } from '../../components/menu-popover/menu-popover.component';
import { PopoverController } from '@ionic/angular';
import { ResourcesProvider } from 'src/app/providers/resources/resources.provider';
import { Resources } from 'src/app/models/resources';
import { CourseCssService } from './course-css.service'
import { WindowService } from '../../services/window.service'
import { Subject, map, takeUntil } from 'rxjs';
import { TeacherStore } from 'src/app/stores/teacher.store';
import { ResourceStore } from 'src/app/stores/resources.store';
import { AutoSavingInfoPopoverComponent } from './auto-saving-info-popover/auto-saving-info-popover.component';
import { Common } from 'src/app/lib/common';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-lesson-plans',
  templateUrl: './lesson-plans.page.html',
  styleUrls: ['./lesson-plans.page.scss'],
})
export class LessonPlansPage implements OnInit {

  readonly courseTypes = ['Active Lesson Plans', 'Archived Lesson Plans']
  readonly sortTypes = ['Collection', 'Start Date', 'Edited Date', 'Class Type']
  readonly months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']

  ngUnsubscribeTeacher = new Subject<void>();
  ngUnsubscribeResources = new Subject<void>();
  
  teacher: Teacher = Teacher.defaults()// = this.teacherProvider.teacher
  resources: Resources = Resources.defaults() // = this.resourcesProvider.resources

  newCourse: Course = null
  searchText: string = ''
  courseType: string = this.courseTypes[0]
  sortType: string = this.sortTypes[1]

  constructor(
    private popoverCtrl: PopoverController,
    private teacherProvider: TeacherProvider,
    private resourcesProvider: ResourcesProvider,
    private preferencesProvider: PreferencesProvider,
    public courseCssService: CourseCssService,
    private windowService: WindowService,
    private teacherStore: TeacherStore,
    private resourceStore: ResourceStore,
    private cookieService: CookieService
  ) {
      this.teacher = Teacher.defaults();
      this.resources = Resources.defaults();

      this.teacher = this.teacherProvider.teacher;
      // this.teacher = this.teacherStore.getTeacher();
      this.teacherStore.state$
          .pipe(takeUntil(this.ngUnsubscribeTeacher))
          .subscribe(() => {
            // this.teacher = this.teacherStore.getTeacher();
            this.teacher = this.teacherProvider.teacher;
            if (this.shouldShowWelcome()) {
              console.log('here')
              this.addNewCourse()
            }
          });

      this.resources = this.resourceStore.getResources();
      this.resourceStore.state$
          .pipe(takeUntil(this.ngUnsubscribeResources))
          .subscribe(() => {
            this.resources = this.resourceStore.getResources();
          })
  }

  ngOnInit() {
    this.windowService.width$.subscribe((value: number) => this.courseCssService.width = value)
    const isAutoSavePopover: string = localStorage?.getItem('autoSavePopover');
    if(isAutoSavePopover !== "false"){
      this.popoverCtrl.create({
        component: AutoSavingInfoPopoverComponent,
        cssClass: 'access-code-popover',
      }).then(popover => {
        popover.present().then(() => Common.ensurePopoverOnScreen());
        popover.onDidDismiss().then(() => {
          localStorage.setItem('autoSavePopover', 'false');
        })
      })
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribeTeacher.next()
    this.ngUnsubscribeTeacher.complete()
    this.ngUnsubscribeResources.next()
    this.ngUnsubscribeResources.complete()
}

  courseArchiveAction() {
    if (this.shouldShowWelcome()) {
      this.addNewCourse()
    }
  }

  shouldShowWelcome() {
    return this.teacher.user.uuid != null && this.courses.length === 0 && this.courseType === this.courseTypes[0]
  }

  get courses(): Course[] {
    let courses = this.courseType === this.courseTypes[0] ? this.teacher?.activeCourses : this.teacher?.archivedCourses
    courses = this.filterCourses(courses)
    courses = this.sortCourses(courses, this.sortType)
    return courses
  }

  private filterCourses(courses: Course[]): Course[] {
    if (!courses) {
      return [];
    }

    return courses.filter( (course: Course) => {
      const searchText = this.searchText.toLowerCase()
      const collection = this.resources?.findCollection(course.collectionUuid) || Collection.defaults()
      return searchText.length === 0 || (
        collection.name.toLowerCase().indexOf(searchText) >= 0 ||
        (course.startDate.year || '').indexOf(searchText) >= 0 ||
        (course.startDate.month || '').toLowerCase().indexOf(searchText) >= 0 ||
        (course.startDate.day || '').indexOf(searchText) >= 0 ||
        course.classType.toLowerCase().indexOf(searchText) >= 0
      )
    })
  }

  private sortCourses(courses: Course[], sourceType: string): Course[] {

    if (sourceType === this.sortTypes[0]) { // Collection
      courses = courses.sort( (a: Course, b: Course) => {
        const aCollection = this.resources?.findCollection(a.collectionUuid) || Collection.defaults()
        const bCollection = this.resources?.findCollection(b.collectionUuid) || Collection.defaults()
        return (aCollection.name < bCollection.name) ? -1 : 1
      })
    } else if (sourceType === this.sortTypes[1]) { // Start Date
      courses = courses.sort( (a: Course, b: Course) => {
        const i = {y: parseInt(a.startDate.year) || '',
                   m: this.months.indexOf(a.startDate.month || ''),
                   d: (parseInt(a.startDate.day) || '')}
        const j = {y: parseInt(b.startDate.year) || '',
                   m: this.months.indexOf(b.startDate.month || ''),
                   d: (parseInt(b.startDate.day) || '')}

        return (
          (i.y < j.y) ||
          (i.y === j.y && i.m < j.m) ||
          (i.y === j.y && i.m === j.m && i.d < j.d)
        ) ? 1 : -1
      })
    } else if (sourceType === this.sortTypes[2]) { // Edited Date
      courses = courses.sort( (a: Course, b: Course) => {
        return (a.dirtyDate < b.dirtyDate) ? 1 : -1
      })
    } else if (sourceType === this.sortTypes[3]) { // Class Type
      courses = courses.sort( (a: Course, b: Course) => {
        return (a.classType < b.classType) ? -1 : 1
      })
    }
    // // most recent on top
    // if(courses && courses.length > 0){
    //   const latestCourse = courses.reduce((a: Course, b: Course) => a.sendDate > b.sendDate ? a : b);
    //   courses.splice(courses.findIndex(item => item.uuid === latestCourse.uuid), 1);
    //   courses.unshift(latestCourse);
    // }
    return courses
  }

  get collections(): Collection[] {
    return this.teacher?.collectionsFrom(this.resources.collections)
  }

  // Sorting

  chooseSortType(event) {
    MenuPopoverComponent.present(this.popoverCtrl, 'lesson-plans-popover', event,
      this.sortTypes.map((sort: string) => {
        return {name: sort, action: () => this.sortType = sort}
      })
    )
  }

  sortyByCollection() {
    this.sortType = this.sortTypes[0]
  }

  sortyByDate() {
    this.sortType = this.sortTypes[1]
  }

  sortyByClassType() {
    this.sortType = this.sortTypes[2]
  }

  chooseCourseType(event) {
    MenuPopoverComponent.present(this.popoverCtrl, 'lesson-plans-popover', event, [
      {name: 'Active Lesson Plans', action: () => {this.courseType = this.courseTypes[0]}},
      {name: 'Archived Lesson Plans', action: () => {this.courseType = this.courseTypes[1]}},
    ])
  }


  // New Course

  addNewCourse() {
    this.courseType = this.courseTypes[0]  // switch to Active Lesson Plans mode
    if(this.newCourse != null){
      this.cancelNewCourse()
      return
    }
    this.newCourse = Course.defaults()
  }

  saveNewCourse(course: Course) {
    this.teacherProvider.addCourse(course)
    this.preferencesProvider.setCourseExpanded(course, true)
    this.newCourse = null
  }

  cancelNewCourse() {
    this.newCourse = null
  }

  trackByCourseUuid(index: number, course: Course): string {
    return course.uuid
  }
}
